import useAlarmsByWorkspace from './useAlarmsByWorkspace';
import useAlarmsByGroup from './useAlarmsByGroup';
import { useAppSelector } from '../../store.model';
import { getMyWorkspaceSelector } from '../../workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../theme/ui/Dashboard/Dashboard.model';
import useAlarmsByWorkspaces from './useAlarmsByWorkspaces';
import useAlarmsByUser from './useAlarmsByUser';
import { patchLoadingState } from '../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';

interface IUseCommanderOfflineProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}
function useAlarms(props: IUseCommanderOfflineProps) {
  const { typeRequest, groupId, workspaceId } = props;
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);

  const userDevicesAlarmCountResponse = useAlarmsByUser({
    skip: typeRequest !== 'user' || !myWorkspace?.id,
  });

  const groupDevicesAlarmCountResponse = useAlarmsByGroup(
    {
      groupId: groupId ?? '',
      workspaceId: workspaceId,
    },
    {
      skip: typeRequest !== 'group' || !groupId,
    }
  );

  const workspaceDevicesAlarmCountResponse = useAlarmsByWorkspace(
    workspaceId ?? myWorkspace?.id,
    {
      skip: typeRequest !== 'workspace' || !workspaceId,
    }
  );

  const workspacesDevicesAlarmCountResponse = useAlarmsByWorkspaces({
    skip: typeRequest !== 'workspaces' || !myWorkspace?.id,
  });

  switch (typeRequest) {
    case 'user':
      return patchLoadingState(userDevicesAlarmCountResponse);
    case 'group':
      return patchLoadingState(groupDevicesAlarmCountResponse);
    case 'workspace':
      return patchLoadingState(workspaceDevicesAlarmCountResponse);
    case 'workspaces':
      return patchLoadingState(workspacesDevicesAlarmCountResponse);
    default:
      return patchLoadingState(userDevicesAlarmCountResponse);
  }
}
export default useAlarms;
